import { Component, Inject } from '@angular/core';
import { MatSnackBarRef as MatSnackBarRef, MAT_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'error-snack-bar',
  templateUrl: 'error-snack-bar.component.html',
  styleUrls: ["./error-snack-bar.component.scss"]
})
export class ErrorSnackBar {
  constructor(public snackBarRef: MatSnackBarRef<ErrorSnackBar>, @Inject(MAT_SNACK_BAR_DATA) public data: ErrorSnackBarData) {}
}

export interface ErrorSnackBarData {
  message?: string;
  detail?: string;
}